import React from 'react';
import { Alert } from 'reactstrap';
import styles from './index.module.scss';
import { AlertProps } from './types';

const { infoAlert } = styles;

export const AlertInfo = (props: AlertProps) => <Alert data-testid={props.testId} color='info' className={infoAlert}>{props.children}</Alert>;
